// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2P4-U"};